import React from "react"
import styles from "./AppLayout.module.scss"

import { Outlet } from "react-router-dom"
import { useLoggedUserData } from "@hooks/useLoggedUserData.ts"
import { AppAuthorizedProfiles } from "@constants/AppAuthorizedProfiles.ts"

import DsNavbar from "@components/layout/DsNavbar/DsNavbar.tsx"
import ChatWidget from "@components/others/ChatWidget/ChatWidget.tsx"
import DsNavbarBackoffice from "@components/layout/DsNavbarBackoffice/DsNavbarBackoffice.tsx"

interface IProps {
	className?: string
}

const AppLayout: React.FC<IProps> = (props) => {
	const { loggedUser } = useLoggedUserData()

	const showChatWidget = loggedUser?.membershipStatus === "PAID"

	return (
		<div className={`${styles.app_layout} ${props.className || ""}`}>
			{loggedUser?.profileType === AppAuthorizedProfiles.MEMBERSHIP && (
				<>
					<DsNavbar className={styles.nav_bar} />

					{showChatWidget && (
						<ChatWidget className={styles.chat_widget} />
					)}
				</>
			)}

			{loggedUser?.profileType === AppAuthorizedProfiles.BACKOFFICE && (
				<DsNavbarBackoffice className={styles.nav_bar} />
			)}

			{loggedUser?.profileType === AppAuthorizedProfiles.BACKOFFICE && (
				<></>
			)}

			<Outlet />
		</div>
	)
}

export default React.memo(AppLayout)
